export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 md:pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100/60 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="w-full max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-4">
              <span className="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full bg-primary-100/80 text-primary-700 whitespace-nowrap">
                <i className="ri-fire-line mr-1"></i>每日更新
              </span>
              <span className="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full bg-accent-100/80 text-accent-700 whitespace-nowrap">
                <i className="ri-star-line mr-1"></i>热门韩漫
              </span>
              <span className="inline-flex items-center px-3 py-1 text-xs font-medium rounded-full bg-secondary-100/80 text-secondary-700 whitespace-nowrap">
                <i className="ri-download-2-line mr-1"></i>免费全集
              </span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight tracking-tight">
              布丁漫画<span className="text-primary-500">·</span>韩漫免费全集阅读平台
            </h1>

            <p className="mt-4 text-lg md:text-xl text-primary-600 font-heading font-semibold">
              精选热门韩漫推荐与排行，下拉式畅读体验
            </p>

            <div className="mt-6 space-y-3">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
                布丁漫画专注韩漫免费阅读，每日同步更新热门韩漫资源，涵盖恋爱、奇幻、动作、悬疑等多元题材。
                采用下拉式阅读设计，无需翻页即可沉浸式畅享韩系画风与精彩剧情，
                是韩漫爱好者的一站式阅读入口。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
                目前站内以校园恋爱与奇幻冒险两大主线为推荐重点，
                每周精选高口碑完结作品加入全集专区，确保阅读体验始终新鲜。
              </p>
            </div>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">200+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-0.5">日更作品</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600 font-heading">5000+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-0.5">收录韩漫</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-600 font-heading">300万+</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-0.5">累计读者</div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>开始阅读
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 text-base font-medium text-foreground-700 bg-background-100 hover:bg-background-200 border border-background-300 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-line"></i>查看排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20illustration%2C%20romantic%20fantasy%20couple%20in%20dramatic%20pose%2C%20digital%20art%2C%20vibrant%20warm%20orange%20and%20coral%20color%20palette%2C%20soft%20gradient%20background%20with%20sparkles%20and%20floating%20petals%2C%20painterly%20texture%2C%20emotional%20atmosphere%2C%20cinematic%20lighting%2C%20modern%20Korean%20illustration%20style&width=900&height=675&seq=hero-manhwa-01&orientation=landscape"
                alt="布丁漫画韩漫推荐主视觉 — 韩系画风插画"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
            </div>

            <div className="mt-4 flex items-center justify-center lg:justify-start gap-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1">
                <i className="ri-shield-check-line text-primary-500"></i>每日同步
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line text-accent-500"></i>高清画质
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-smartphone-line text-secondary-500"></i>下拉阅读
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}